// extracted by mini-css-extract-plugin
export default {"container":"A--z","creativeContainer":"B--z","copy":"C--z","cta":"D--z","disabled":"E--z","flipped":"F--z","productCard":"G--z"};